import * as type from "./type";

export const getVendorUserListRequest = (data) => {
  return {
    type: type.GET_VENDOR_USER_LIST_REQUEST,
    payload: data,
  };
};
export const getVendorUserListSuccess = (data) => {
  return {
    type: type.GET_VENDOR_USER_LIST_SUCCESS,
    payload: data,
  };
};
export const addVendorUserRequest = (data) => {
  return {
    type: type.ADD_VENDOR_USER_REQUEST,
    payload: data,
  };
};
export const addVendorUserSuccess = (data) => {
  return {
    type: type.ADD_VENDOR_USER_SUCCESS,
    payload: data,
  };
};
export const activeInactiveVendorUserRequest = (data) => {
  return {
    type: type.ACTIVE_INACTIVE_VENDOR_USER_REQUEST,
    payload: data,
  };
};
export const activeInactiveVendorUserSuccess = (data) => {
  return {
    type: type.ACTIVE_INACTIVE_VENDOR_USER_SUCCESS,
    payload: data,
  };
};
export const resendVendorUserEmailRequest = (data) => {
  return {
    type: type.RESEND_VENDOR_USER_EMAIL_REQUEST,
    payload: data,
  };
};
export const resendVendorUserEmailSuccess = (data) => {
  return {
    type: type.RESEND_VENDOR_USER_EMAIL_SUCCESS,
    payload: data,
  };
};
export const getUnassignedVendorUserListRequest = (data) => {
  return {
    type: type.GET_UNASSIGNED_VENDOR_USER_LIST_REQUEST,
    payload: data,
  };
};
export const getUnassignedVendorUserListSuccess = (data) => {
  return {
    type: type.GET_UNASSIGNED_VENDOR_USER_LIST_SUCCESS,
    payload: data,
  };
};
export const assignVendorUserRequest = (data) => {
  return {
    type: type.ASSIGN_VENDOR_USER_REQUEST,
    payload: data,
  };
};
export const assignVendorUserSuccess = (data) => {
  return {
    type: type.ASSIGN_VENDOR_USER_SUCCESS,
    payload: data,
  };
};
export const clearVendorUserRequest = (data) => {
  return {
    type: type.CLEAR_VENDOR_USER_REQ,
    payload: data,
  };
};
